/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  DefaultMessageReceiver,
  DefaultMessageReceiverInterface,
} from "../DefaultMessageReceiver";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "sygmaHandlers",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "recoverGas",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ActionFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "InsufficientGasLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "InsufficientNativeBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "InsufficientPermission",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidContract",
    type: "error",
  },
  {
    inputs: [],
    name: "ReturnNativeLeftOverFailed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "transactionId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenSend",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Executed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "transactionId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenSend",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TransferRecovered",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "SYGMA_HANDLER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_recoverGas",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getRoleMemberIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    stateMutability: "payable",
    type: "receive",
    payable: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenSent",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "message",
        type: "bytes",
      },
    ],
    name: "handleSygmaMessage",
    outputs: [],
    stateMutability: "payable",
    type: "function",
    payable: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenSent",
        type: "address",
      },
      {
        internalType: "address payable",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "startingNativeBalance",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "nativeValue",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "callTo",
            type: "address",
          },
          {
            internalType: "address",
            name: "approveTo",
            type: "address",
          },
          {
            internalType: "address",
            name: "tokenSend",
            type: "address",
          },
          {
            internalType: "address",
            name: "tokenReceive",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct DefaultMessageReceiver.Action[]",
        name: "actions",
        type: "tuple[]",
      },
    ],
    name: "performActions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "transferBalanceAction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type DefaultMessageReceiverConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DefaultMessageReceiverConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DefaultMessageReceiver__factory extends ContractFactory {
  constructor(...args: DefaultMessageReceiverConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "DefaultMessageReceiver";
  }

  deploy(
    sygmaHandlers: string[],
    recoverGas: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DefaultMessageReceiver> {
    return super.deploy(
      sygmaHandlers,
      recoverGas,
      overrides || {}
    ) as Promise<DefaultMessageReceiver>;
  }
  getDeployTransaction(
    sygmaHandlers: string[],
    recoverGas: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      sygmaHandlers,
      recoverGas,
      overrides || {}
    );
  }
  attach(address: string): DefaultMessageReceiver {
    return super.attach(address) as DefaultMessageReceiver;
  }
  connect(signer: Signer): DefaultMessageReceiver__factory {
    return super.connect(signer) as DefaultMessageReceiver__factory;
  }
  static readonly contractName: "DefaultMessageReceiver";
  public readonly contractName: "DefaultMessageReceiver";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DefaultMessageReceiverInterface {
    return new utils.Interface(_abi) as DefaultMessageReceiverInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DefaultMessageReceiver {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as DefaultMessageReceiver;
  }
}
